// extracted by mini-css-extract-plugin
export default {"container":"kTvzNCKZ0zz3KYLKPYTuTw=="};